import { Organisation, ActiveStatus, PatientSummary, User } from "../types";

export const createTeamDictionary = (
    teams: Organisation[] | undefined
): Record<string, Organisation> => {
    if (!teams) {
        return {};
    }

    const teamDictionary = teams.reduce(
        (acc, team) => {
            acc[team.organisationId] = team;
            return acc;
        },
        {} as Record<string, Organisation>);

    teamDictionary[""] = {
        organisationId: "",
        color: "grey",
        name: "Guest",
        usersIds: [],
        adminIds: [],
        type: ActiveStatus.Inactive,
        created: new Date(),
    }

    return teamDictionary
}

export const createUserDictionary = (
    users: User[] | undefined
): Record<string, User> => {

    if (!users) {
        return {};
    }

    return users.reduce(
        (acc, user) => {
            acc[user.userId] = user;
            return acc;
        },
        {} as Record<string, User>);
}

export const createPatientDictionary = (
    patients: PatientSummary[] | undefined
): Record<string, PatientSummary> => {

    if (!patients) {
        return {};
    }

    return patients.reduce(
        (acc, patient) => {
            acc[patient.patientId] = patient;
            return acc;
        },
        {} as Record<string, PatientSummary>);
}